export default "__VITE_ASSET__BN5oDl6b__"